export const images = [
    { id:1, original: '/images/services/2/sub-categories/1/c2-s1-p1.jpg',},
]
